/*--------------------------------------------------------------
# Custom scripts for Vertical tabs block
--------------------------------------------------------------*/

document.addEventListener("DOMContentLoaded", function() {
    // Select all second tabs outputted
    const verticalNavPills = document.querySelectorAll('.nav-pills button:nth-child(2)');
    
    // loop through each set of vertical nav tabs on the page and set second one to show
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);
        
        // Show the second tab
        secondVerticalTab.show();
    });

    // on load replace mobile dropdown toggle with selected item
    const secondNavpillText = jQuery('.nav-pills button:nth-child(2)').text();
    jQuery('.nav-pills button:nth-child(2)').closest('.dropdown-menu').prev('.dropdown-toggle').text(secondNavpillText);
});

// refresh slick slider when tabs are shown so it gets the correct height
jQuery('button[data-bs-toggle="pill"]').on('shown.bs.tab', function (e) {
    // jQuery('.tab-content .blog-reel-slider').slick('setPosition');

    const target = jQuery(e.target).attr("data-bs-target"); // Get the target tab content ID
    const pillPaneSlickSliders = jQuery(target).find('.slick-slider'); // Find Slick slider in the tab content

    if (pillPaneSlickSliders.length) { // Check if Slick slider exists
        pillPaneSlickSliders.slick('setPosition');
    }
});

// on click of dropdown item replace mobile dropdown toggle with selected item
jQuery('.nav-pills button').on('click', function(){
    const selectedNavpillText = jQuery(this).text();
    jQuery(this).closest('.dropdown-menu').prev('.dropdown-toggle').text(selectedNavpillText);
});


/* 
Actions for the links under tabs.
*/
// Instructional Videos
jQuery('.inst-vid-link').on('click', function(e){
    // Get the tab name - should match the name of this link
    var tabname = ( jQuery('.inst-vid-link span.ms-2').text() );

    // Select the videos tab.
    const verticalNavPills = document.querySelectorAll('.nav-tabs button[data-text="' + tabname + '"]');

    // Now activate that tab.
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);       
        // Show it.
        secondVerticalTab.show();
    });
    return true;
});
// Related Products
jQuery('.rel-prods').on('click', function(e){
    // Get the tab name - should match the name of this link
    var tabname = ( jQuery('.rel-prods span.ms-2').text() );

    // Select the videos tab.
    const verticalNavPills = document.querySelectorAll('.nav-tabs button[data-text="' + tabname + '"]');

    // Now activate that tab.
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);       
        // Show it.
        secondVerticalTab.show();
    });
    return true;
});
// Materials & Downloads
jQuery('.mat-downs').on('click', function(e){
    // Get the tab name - should match the name of this link
    tabname = ( jQuery('.mat-downs span.ms-2').text() );

    // Select the videos tab.
    const verticalNavPills = document.querySelectorAll('.nav-tabs button[data-text="' + tabname + '"]');

    // Now activate that tab.
    verticalNavPills.forEach(function(secondVerticalTabTriggerEl) {
        const secondVerticalTab = new bootstrap.Tab(secondVerticalTabTriggerEl);       
        // Show it.
        secondVerticalTab.show();
    });
    return true;
});